import * as React from 'react';

export const ActionIconSvg = () => (
  <svg viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 4.5L8 7V2L11 4.5Z" fill="currentColor" />
    <path d="M8.5 4.07182V5.07182H4.5V4.07182H8.5Z" fill="currentColor" />
    <path
      d="M5 2.03586V7.03586H0V2.03586H5ZM1 6.03586H4V3.03586H1V6.03586Z"
      fill="currentColor"
    />
  </svg>
);
